module.exports = __webpack_public_path__ + "img/bg.38d3d786.jpg";